
import {InjectionToken} from '@angular/core';

export const ISMEMBER_BASE_URL = new InjectionToken<string>(
    'Base Url for MEMBER Api', {
      providedIn: 'root',
      factory: () => 'localhost',
    },
);
